import React, { useMemo } from "react";
import { useSize, useDebounce } from "@umijs/hooks";

interface AppMainProps {
  aspectRatio: number;
}

export const SizeContext = React.createContext(getSizeFun(1920, 1080));

function getSizeFun(w: number, h: number) {
  return (n: number, isH = false) =>
    Number((n / (isH ? 1440 / h : 2560 / w)).toFixed(6));
}

const AppMain: React.FC<AppMainProps> = ({ aspectRatio, children }) => {
  const [size, ref] = useSize<HTMLDivElement>();
  const { width: w = 0, height: h = 0 } = useDebounce(size, 500);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const innerSize = useMemo(() => {
    if (w / h >= aspectRatio) {
      return { w: Math.min(w, h * aspectRatio), h };
    } else {
      return { w, h: Math.min(h, w / aspectRatio) };
    }
  }, [w, h, aspectRatio]);
  const getSize = useMemo(() => getSizeFun(w, h), [w, h]);

  return (
    <SizeContext.Provider value={getSize}>
      <main ref={ref} className="relative flex-auto overflow-hidden">
        {w !== 0 && h !== 0 && (
          <div
            className="absolute overflow-hidden"
            style={{
              top: "50%",
              left: "50%",
              width: `${w}px`,
              height: `${h}px`,
              transform: "translate(-50%, -50%)",
            }}
          >
            {children}
          </div>
        )}
      </main>
    </SizeContext.Provider>
  );
};

export default AppMain;
